/* eslint-disable @typescript-eslint/member-delimiter-style */
import request from 'common/utils/requests'
import type { Order, ChoiceActionParams, ChoiceActionRes, Orbitpay } from '@/types/order'

/** 获取订单信息 */
export const getOrderInfo = () => request.get<null, Order>(`/merchant/checkout/counter`)

/** 获取二维码 */
export const getQR = () => request.get<null, { qrcode: string }>(`/merchant/checkout/counter/qrpic`)

//  Choice事件接口
export const choiceAction = (data: ChoiceActionParams) =>
  request.post<ChoiceActionParams, ChoiceActionRes>(
    `/merchant/checkout/counter/handle/action`,
    data,
  )

// Orbitpay 收银台
export const getOrbitpay = (data: Orbitpay) => request.post<Orbitpay, any>(`/merchant/checkout/counter/handle/action`, data)
